<template>
  <div class="login-wrapper">
    <div class="login-card">
      <!-- 상단 브랜드 -->
      <div class="login-brand">
        <div class="login-brand-icon">
          <v-icon icon="mdi-shield-account" size="32" color="primary" />
        </div>
        <p class="login-title">알공 관리자 페이지</p>
        <p class="login-subtitle">Argong Admin Dashboard</p>
      </div>

      <!-- 폼 -->
      <div class="login-form">
        <v-text-field
          density="compact"
          @keyup.enter="login()"
          variant="outlined"
          v-model="id"
          label="아이디"
          prepend-inner-icon="mdi-account-outline"
          color="primary"
        ></v-text-field>

        <v-text-field
          density="compact"
          @keyup.enter="login()"
          variant="outlined"
          v-model="password"
          type="password"
          label="비밀번호"
          prepend-inner-icon="mdi-lock-outline"
          color="primary"
        ></v-text-field>

        <v-btn
          block
          height="44"
          variant="flat"
          color="primary"
          @click="login()"
          class="login-btn"
        >
          로그인
        </v-btn>
      </div>

      <!-- 하단 바 -->
      <div class="login-footer-bar"></div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    if (this.$store.state.token) {
      this.$router.replace({ path: "/user/school-manage" });
    }
  },
  data() {
    return {
      id: "",
      password: "",
    };
  },
  methods: {
    login() {
      this.$store.dispatch("LOGIN", { id: this.id, password: this.password });
    },
  },
};
</script>

<style scoped>
.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100dvh;
  background: var(--bg-canvas);
  padding: var(--space-5);
}

.login-card {
  background: var(--bg-surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-default);
  box-shadow: var(--shadow-md);
  width: 100%;
  max-width: 440px;
  position: relative;
  overflow: hidden;
}

.login-brand {
  text-align: center;
  padding: 36px 32px 24px;
}

.login-brand-icon {
  width: 60px;
  height: 60px;
  background: var(--color-primary-50);
  border-radius: var(--radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto var(--space-4);
}

.login-title {
  font-family: var(--font-family-base);
  font-size: var(--font-h2-size);
  line-height: var(--font-h2-line);
  font-weight: var(--font-h2-weight);
  color: var(--text-primary);
  margin: 0 0 6px;
}

.login-subtitle {
  font-family: var(--font-family-base);
  font-size: var(--font-small-size);
  line-height: var(--font-small-line);
  color: var(--text-tertiary);
  margin: 0;
}

.login-form {
  padding: 0 32px 32px;
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.login-btn {
  font-family: var(--font-family-base);
  font-size: var(--font-body-size);
  font-weight: 600;
  color: var(--text-on-primary) !important;
  margin-top: var(--space-2);
  letter-spacing: 0.02em;
  border-radius: var(--radius-md);
}

.login-footer-bar {
  height: 4px;
  background: var(--color-primary-600);
}

@media (max-width: 480px) {
  .login-brand { padding: 28px 20px 20px; }
  .login-form { padding: 0 20px 24px; }
  .login-title { font-size: 20px; }
}
</style>
